<template>
  <form-group
    :errors="internalErrors"
    :label="label"
    class="product-family-compatibility-requirement-alternatives-manager"
  >
    <div
      :key="index"
      class="product-family-compatibility-requirement-alternatives-manager__group"
      v-for="(alternative, index) in alternatives"
    >
      <div class="uk-margin-small uk-grid-column-small" uk-grid>
        <div class="uk-width-expand">
          <product-family-combobox
            :disabled="disabled"
            :filter="{
              bundle: false,
              omittedIds: omittedFamilyIds[index],
            }"
            @input="onChange"
            multiple
            ref="familySelectors"
            v-model="alternative.requiredFamilies"
          />
        </div>
        <div class="uk-width-auto">
          <common-button @click="removeGroup(index)" icon="trash" ref="button" />
        </div>
      </div>
    </div>

    <common-button
      @click="addEmptyGroup"
      icon="plus"
      ref="addGroupButton"
    >{{$t('actions.addGroup')}}</common-button>
  </form-group>
</template>

<script>
import Vue from 'vue';
import { chain, cloneDeep } from 'lodash';
import BaseInput from '@/mixins/BaseInput';
import CommonButton from '@/components/CommonButton';
import DataGridActions from '@/components/DataGridActions';
import Grid from '@/components/Grid';
import ProductFamilyCombobox from '@/components/ProductFamilyCombobox';

function getAlternatives(items) {
  return items.map((item, index) => ({
    group: index + 1,
    requiredFamilies: cloneDeep(item.requiredFamilies),
  }));
}

function getErrors(errors) {
  return cloneDeep(errors || []);
}

export default {
  name: 'product-family-compatibility-requirement-alternatives-manager',
  mixins: [BaseInput],
  components: {
    CommonButton,
    DataGridActions,
    Grid,
    ProductFamilyCombobox,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    unselectableFamilyIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      alternatives: getAlternatives(this.value),
      internalErrors: getErrors(this.errors),
    };
  },
  watch: {
    value: {
      handler(value) {
        this.alternatives = getAlternatives(value);
      },
      deep: true,
    },
    errors(errors) {
      this.internalErrors = getErrors(errors);
    },
  },
  computed: {
    omittedFamilyIds() {
      return this.alternatives.map((alternative) => {
        const ids = new Set();

        this.unselectableFamilyIds.forEach((familyId) => {
          ids.add(familyId);
        });

        alternative.requiredFamilies.forEach((requiredFamily) => {
          ids.add(requiredFamily.id);
        });

        return Array.from(ids);
      });
    },
  },
  methods: {
    addEmptyGroup() {
      this.resetErrors();
      this.alternatives.push({
        group: this.alternatives.length,
        requiredFamilies: [],
      });
      this.$refs.addGroupButton.focus();
    },
    removeGroup(index) {
      Vue.delete(this.alternatives, index);
      this.onChange();
    },
    onChange() {
      this.resetErrors();

      const updatedValue = chain(this.alternatives)
        .filter(alternative => alternative.requiredFamilies.length > 0)
        .map(alternative => ({
          requiredFamilies: alternative.requiredFamilies,
        }))
        .value();

      this.$emit('input', updatedValue);
      this.$emit('change', updatedValue);
    },
    resetErrors() {
      this.internalErrors = [];
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          addGroup: 'Gruppe hinzufügen',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductFamilyCompatibilityRequirementAlternativesManager.vue?a51c4408